import React, { useEffect } from 'react'
import { axios } from '../../axios';
import Chart from 'chart.js/auto';

// Espejo de theme-001 Admin/components/Visitas (port bloque 5, nov 2026): las
// dos instancias de Chart se destruyen en el cleanup del efecto. Sin eso, cada
// visita a la ruta deja una instancia huérfana con su listener de resize, y
// si el canvas llegara a reutilizarse Chart.js truena con "Canvas is already
// in use". Aquí los datos llegan por axios en vez del hook.

const Visitas = () => {

	useEffect(()=>{
		let bar = null
		let line = null

		axios.get('/api/seller/visita/company_profile')
		.then(r => {
			const visitas = Array.isArray(r.data) ? r.data : []
			const labels = visitas.map(r=>r.fecha)
			const values = visitas.map(r=>r.visitas)

			bar = new Chart(document.getElementById('barchart'), {
				type: 'bar',
				data: {
					labels,
					datasets: [{ label: '# Visits', data: values, borderWidth: 1, backgroundColor: '#BE1D2C' }]
				},
				options: { responsive: true, plugins: { legend: { position: 'top' }, title: { display: true, text: '' } } },
			})

			line = new Chart(document.getElementById('linechart'), {
				type: 'line',
				data: {
					labels,
					datasets: [{ label: '# Visits', data: values, borderWidth: 1, backgroundColor: '#BE1D2C' }]
				},
				options: { responsive: true, plugins: { legend: { position: 'top' }, title: { display: true, text: '' } } },
			})
		})
		.catch(e=>alert(e))

		// si el usuario sale antes de que responda el GET, bar/line siguen null
		return () => { bar?.destroy(); line?.destroy() }

	}, [])

	return(
		<div className='card-panel'>
			<h4>Visits</h4>
			<div>
				<canvas id="barchart"></canvas>
				<canvas id="linechart"></canvas>
			</div>
		</div>
	)
}

export default Visitas
